<template>
  <div class="text botter-conversation botter-hero botter-trivia">
    <div class="d-flex align-end " :class="getAlignment()">
      <user-chat-image :sender="con.sender" v-if="con.sender.sender_type === 'BOT' && lastMessageGroup"/>
      <div class="full-width">
        <div  class="botter-text" :class="getColor()" v-if="con.payload">
          <p v-html="common.formatText(con.payload)" :class="common.getTextAlignment(con.payload)">
          </p>
        </div>
      </div>
    </div>

    <div class="botter-buttons-list" v-if="displayBtn">
      <div class="d-inline-block" v-for="(btn,index) in con.actions" :key="index" @click="displayBtn = false">
        <a  v-if="btn.type === 'call'">
          <b-btn>
            {{btn.title}}
          </b-btn>
        </a>
        <a  target="_blank" v-if="btn.type === 'openUrl'">
          <b-btn>
            {{btn.title}}
          </b-btn>
        </a>
        <div >
          <b-btn v-if="btn.type === 'postBack'">
            {{btn.title}}
          </b-btn>
        </div>
      </div>
    </div>
    <!--    <div v-if="lastMessageGroup" class="chat-date d-flex" :class="getAlignment()">{{common.formatDate(con.date)}}</div>-->
  </div>
</template>

<script>
  import userChatImage from "./common/userChatImage";
  import { Carousel, Slide } from 'vue-carousel';
  import common from "../../../utils/common";
  export default {
    name: "teriviaQuestion",
    components: {
      userChatImage,
      Carousel,
      Slide
    },
    props: {
      con: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      index: {
        type: Number,
        default: ()=> {
          return 0
        }
      }
    },
    data() {
      return {
        common,
        displayBtn: true
      }
    },
    methods: {
      getAlignment() {
        if (this.con.type==='user') {
          return 'justify-end'
        } else if(this.con.type==='bot') {
          return 'justify-start'
        }
      },
      getColor() {
        if (this.con.type==='user') {
          return 'botter-user-text'
        } else if(this.con.type==='bot') {
          return 'botter-bot-text'
        }
      },
      postBack(data) {
         this.$store.dispatch('pushMessage', {
          slug: 'text',
          payload: data.title,
          type: 'user',
          lastMessageGroup: true
        })
        this.$emit('postBack',data)
      }
    },
    computed: {
      lastMessageGroup() { return true }
    }
  }
</script>

<style lang="scss">
  .trivia {
    .VueCarousel-inner {
      // flex-basis: auto !important;
    }
    .VueCarousel-navigation-button {
      background-color: white !important;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      outline: none !important;
      align-items: center;
      justify-content: center;
      padding: 0 !important;
    }

    .VueCarousel-navigation-next {
      right: 0px !important;
    }

    .VueCarousel-navigation-prev {
      left: -8px !important;
    }
  }


</style>
